module.exports = __webpack_public_path__ + "static/media/cardFifth.be3a6a02.svg";